import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useAuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const ImpersonationBanner = () => {
  const { isImpersonating, stopImpersonation, loggedInUser } = useAuthContext();
  const navigate = useNavigate();

  if (!isImpersonating) {
    return null;
  }

  const handleStopImpersonating = () => {
    stopImpersonation();
    navigate('/admin/usuarios', { replace: true });
  };

  return (
    <Alert variant="warning" className="text-center mb-0 rounded-0" style={{ position: 'sticky', top: 0, zIndex: 1050 }}>
      Você está personificando <strong>{loggedInUser?.nome || 'usuário'}</strong>.
      <Button variant="dark" size="sm" className="ms-3" onClick={handleStopImpersonating}>Voltar para Admin</Button>
    </Alert>
  );
};

export default ImpersonationBanner;